module.exports = __webpack_public_path__ + "static/media/homeButtonFilledWhite.cc566f0b.svg";